import React from 'react';

import { useRecoilValue } from 'recoil';
import { userSNSState } from 'recoils/user/userState';
import styled from 'styled-components';

import PopUpButton from 'components/button/PopUpButton';

import usePopupButton from 'hooks/components/usePopupButton';
import useHeader from 'hooks/menu/useHeader';

import { clickToGTM } from 'utils/seo/seoGTMUtil';

const UserMenuPopupContent = () => {
  const userSnsInfo = useRecoilValue(userSNSState);
  const { visiblePopupButton, openPopupButton, closePopupButton } =
    usePopupButton();
  const { onUserBtnClick, onLogoutBtnClick } = useHeader();

  return (
    <PopUpButton
      text={
        <EmailText $isEmail={userSnsInfo?.nickname || userSnsInfo?.email}>
          {userSnsInfo.nickname || userSnsInfo.email || ''}
        </EmailText>
      }
      className="user_popup_btn"
      isopen={visiblePopupButton.isopen && visiblePopupButton.type === 'user'}
      onClick={() => openPopupButton('user')}
      onClose={closePopupButton}
    >
      <UserMenuInfo>
        <UserMenuItem
          onClick={(e) => {
            // GTM 이벤트 전송
            clickToGTM({
              target: '회원 정보',
              id: `header-user-info`,
              url: '/user-info',
            });
            onUserBtnClick(e);
          }}
        >
          회원 정보
        </UserMenuItem>
        <UserMenuItem
          onClick={(e) => {
            // GTM 이벤트 전송
            clickToGTM({
              target: '로그아웃',
              id: `header-logout`,
              url: '/',
            });
            onLogoutBtnClick(e);
          }}
        >
          로그아웃
        </UserMenuItem>
      </UserMenuInfo>
    </PopUpButton>
  );
};

export default UserMenuPopupContent;

const UserMenuInfo = styled.ul`
  list-style: none;
  width: 120px;
  background: ${({ theme }) => theme.color.gray30};
  color: ${({ theme }) => theme.color.white};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.color.primaryDark};
  border-radius: 4px;
`;

const UserMenuItem = styled.li`
  cursor: pointer;
  padding: 10px;
  font-size: 13px;
  border-bottom: 1px solid ${({ theme }) => theme.color.primaryDark};
  &.last-child {
    border-bottom: 0;
  }
  &:hover {
    background: ${({ theme }) => theme.color.primaryDark};
  }
`;

const EmailText = styled.span`
  width: ${({ $isEmail }) => ($isEmail ? 'max-content' : '160px')};
`;
